import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_1788354054 from "../../../../../packages/component/src/components/number-picker/demo/demo1.js?loadDemo";
import legacyImportDemo_1098461061 from "../../../../../packages/component/src/components/number-picker/demo/demo2.js?loadDemo";
import legacyImportDemo_439241988 from "../../../../../packages/component/src/components/number-picker/demo/demo3.js?loadDemo";
import legacyImportDemo_1451919235 from "../../../../../packages/component/src/components/number-picker/demo/demo4.js?loadDemo";
import legacyImportDemo_926803714 from "../../../../../packages/component/src/components/number-picker/demo/demo5.js?loadDemo";
import legacyImportDemo_3869419649 from "../../../../../packages/component/src/components/number-picker/demo/demo6.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_1788354054,
  legacyImportDemo_1098461061,
  legacyImportDemo_439241988,
  legacyImportDemo_1451919235,
  legacyImportDemo_926803714,
  legacyImportDemo_3869419649,
  React
};